<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-forma-pagamento') {
            next({ name: 'ven-forma-pagamento-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-forma-pagamento') {
            this.$router.push({ name: 'ven-forma-pagamento-list' });
        }
    },
};
</script>
